module.exports = __webpack_public_path__ + "img/Benin.5f2cfdd8.svg";